/* tslint:disable */

import { AvailableIntervalResource } from "./AvailableIntervalResource";


export class AvailableAppointmentResource{

	date: string;

	intervals: AvailableIntervalResource[];

}
